import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';

export const LogsNoItems = () => {
  const { t } = useAppTranslation();

  return (
    <div className="text-primary flex flex-col items-center justify-center gap-2 text-sm">
      <p className="text-primary text-lg">{t('noResults')}</p>
      <span className="text-muted-foreground text-base">
        {t('components.ticketDetails.logForm.noLogs.description')}
      </span>
    </div>
  );
};
